// extracted by mini-css-extract-plugin
var _1 = "Vah2FJjC3P";
export { _1 as "themeSwitcher" }
